export default __webpack_public_path__ + "static/media/annotationicon_45_x_45.80b20b13.svg";